export default __webpack_public_path__ + "static/media/subscription.56c88b5b.png";